import * as swcHelpers from '@swc/helpers';
import { useDynamicModule } from '@grandvisionhq/utils';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const { GoogleMap , InfoWindow , MarkerClusterer , LoadScript , Marker  } = yield import(/* webpackChunkName: "react-google-maps" */ '@react-google-maps/api');
        return {
            GoogleMap,
            InfoWindow,
            MarkerClusterer,
            LoadScript,
            Marker
        };
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const useGoogleMapsModule = ()=>useDynamicModule(loadModule, '@react-google-maps/api', [])
;

export { useGoogleMapsModule };
//# sourceMappingURL=external-module.js.map
